export default (date) => {
    const newDate = new Date(date);
    let year = newDate.getFullYear();
    let month = newDate.getMonth();
    let day = newDate.getDate();
    return year + '-' + (month + 1) + '-' + day;
}